__turbopack_context__.v({
  "banner": "CreateKidsBanner-module-scss-module__l_rvda__banner",
  "logo": "CreateKidsBanner-module-scss-module__l_rvda__logo",
  "title": "CreateKidsBanner-module-scss-module__l_rvda__title",
});
